import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable()
export class RedirectToInternalServerHandler{
    constructor(
        private router: Router,
    ) { }

    public handle(): void {
        this.router.navigate(['page-internal-server-error'], {replaceUrl: true});
    }
}
